import { ICodeDescription } from '../model/ICodeDescription'
import axiosInstance from '../services/apis'

export const getCodeDescription = async (code: string, language: number) => {
    const response: ICodeDescription[] = await axiosInstance.get(
        `/api/CodeDescription/${code}/${language}`
    )
    return response
}
